export const printAscii = () => {
	console.log(`
         ____    _    ____ ___ ___
        / ___|  / \\  |  _ \\_ _/ _ \\\ 
       | |     / _ \\ | |_) | | | | |\n\
       | |___ / ___ \\|  __/| | |_| |\n\
        \\____/_/   \_\_|  |  |_|\\___/ 
    `)
}
